import { Injectable } from "@angular/core";
import { Subject, Observer, Observable, EMPTY, timer, MonoTypeOperatorFunction, iif, throwError, of } from 'rxjs';
import { share, switchAll, catchError, delayWhen, map, delay, concatMap } from 'rxjs/operators';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { delay as delayOperator, retryWhen, scan, tap } from 'rxjs/operators';


@Injectable()
export class WebSocketsService {
  constructor() { }

  private socket$: WebSocketSubject<any>;
  private messagesSubject$ = new Subject();
  public messages$ = this.messagesSubject$.pipe(switchAll(), catchError(e => { throw e }));

  public connect(url, cfg: { reconnect: boolean } = { reconnect: false }): void {

    if (!this.socket$ || this.socket$.closed) {
      this.socket$ = this.getNewWebSocket(url);
      const messages = this.socket$.pipe(cfg.reconnect ? this.reconnect : o => o,
        map(res => {
          return res['data']
        }),
        tap({
          error: error => error,
        }), catchError(_ => EMPTY));
      this.messagesSubject$.next(messages);
    }
  }

  private getNewWebSocket(url) {
    return webSocket({
      url: url,
      closeObserver: {
        next: () => {
          this.socket$ = undefined;
          let cfg = { reconnect: true }
          this.connect(url, cfg);
        }
      },
    });
  }

  private reconnect(observable: Observable<any>): Observable<any> {
    return observable
      .pipe(
        delay(100_000),
        retryWhen(errors => errors.pipe(
          // Use concat map to keep the errors in order and make sure they
          // aren't executed in parallel
          concatMap((e, i) => {
            console.log(e, i)
            // Executes a conditional Observable depending on the result
            // of the first argument
            return iif(
              () => i === 0,
              // If the condition is true we throw the error (the last error)
              throwError(e),
              // Otherwise we pipe this back into our stream and delay the retry
              of(e).pipe(delay(100000))
            )
          })
        ))
      )
  }

  close() {
    this.socket$.complete();
  }
}

export function retryWithDelay<T>(
  delay: number,
  count = 1
): MonoTypeOperatorFunction<T> {
  return (input) =>
    input.pipe(
      retryWhen((errors) =>
        errors.pipe(
          scan((acc, error) => ({ count: acc.count + 1, error }), {
            count: 0,
            error: undefined as any,
          }),
          tap((current) => {
            if (current.count > count) {
              throw current.error;
            }
          }),
          delayOperator(delay)
        )
      )
    );
}

